"use client";

import { Flex, Spinner } from "@radix-ui/themes";
import dynamic from "next/dynamic";

export const ConsultationResults = dynamic(
  async () =>
    (await import("@/src/app/consultations/[slug]/ConsultationResultsClient"))
      .ConsultationResultsClient,
  {
    loading: () => (
      <Flex justify="center" p="9">
        <Spinner size="3" />
      </Flex>
    ),
    ssr: false,
  },
);
